module.exports = __webpack_public_path__ + "static/0037-7ece4f513b29b5b72e9819bdaff7aba1.png";